import React from 'react';

import { Container, TextContainer, Title, Message } from './styled';
import { Props } from './types';

export function Alert(props: Props) {
  const { type = 'success', title = '', message = '' } = props;

  return (
    <Container type={type}>
      <TextContainer>
        {title && <Title>{title}</Title>}
        {message && <Message>{message}</Message>}
      </TextContainer>
    </Container>
  );
}
